import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "notsupportedbrowser"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  style: {
    "margin-left": "10px",
    "margin-right": "10px"
  },
  href: "https://www.google.com/chrome/browser-tools/"
}, "Chrome", -1);
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "height": "100vh",
    "width": "100vw"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h1", null, "One Second..."), /*#__PURE__*/_createElementVNode("p", null, "We're Connecting you...")])], -1);
var _hoisted_5 = [_hoisted_4];
var _hoisted_6 = {
  key: 5
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  key: 41,
  "class": "MainApplicationHolder"
};
var _hoisted_9 = {
  key: 2,
  "class": "floatingText-ai"
};
var _hoisted_10 = {
  key: 3,
  "class": "floatingText"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PurchaseTokens = _resolveComponent("PurchaseTokens");
  var _component_BluetoothRingController = _resolveComponent("BluetoothRingController");
  var _component_WebsiteComponent = _resolveComponent("WebsiteComponent");
  var _component_TokensFalling = _resolveComponent("TokensFalling");
  var _component_FloatingImage = _resolveComponent("FloatingImage");
  var _component_ExperienceSelector = _resolveComponent("ExperienceSelector");
  var _component_VoiceController = _resolveComponent("VoiceController");
  var _component_MainMenu = _resolveComponent("MainMenu");
  var _component_LeaveReview = _resolveComponent("LeaveReview");
  var _component_DownvoteComponent = _resolveComponent("DownvoteComponent");
  var _component_UpgradeVoices = _resolveComponent("UpgradeVoices");
  var _component_ClothingStore = _resolveComponent("ClothingStore");
  var _component_HandleAIResponse = _resolveComponent("HandleAIResponse");
  var _component_ActivityLogs = _resolveComponent("ActivityLogs");
  var _component_ActionBar = _resolveComponent("ActionBar");
  var _component_LocationsPermissionsNeeded = _resolveComponent("LocationsPermissionsNeeded");
  var _component_AppFeatures = _resolveComponent("AppFeatures");
  var _component_PermissionsComponent = _resolveComponent("PermissionsComponent");
  var _component_NewAvatarSelector = _resolveComponent("NewAvatarSelector");
  var _component_UpgradeMembership = _resolveComponent("UpgradeMembership");
  var _component_faqComponent = _resolveComponent("faqComponent");
  var _component_Pageloader = _resolveComponent("Pageloader");
  var _component_UserRegistrationPurple = _resolveComponent("UserRegistrationPurple");
  var _component_UserLoginBlue = _resolveComponent("UserLoginBlue");
  var _component_AppExpectations = _resolveComponent("AppExpectations");
  var _component_IntroSexualHowTo = _resolveComponent("IntroSexualHowTo");
  var _component_ShowXRatedConfirmation = _resolveComponent("ShowXRatedConfirmation");
  var _component_CompanionPreference = _resolveComponent("CompanionPreference");
  var _component_CustomerGender = _resolveComponent("CustomerGender");
  var _component_IntroGallery = _resolveComponent("IntroGallery");
  var _component_IntroQuickMessage = _resolveComponent("IntroQuickMessage");
  var _component_IntroAvatarViewer = _resolveComponent("IntroAvatarViewer");
  var _component_IntroVoice = _resolveComponent("IntroVoice");
  var _component_IntroPersonality = _resolveComponent("IntroPersonality");
  var _component_IntroInterests = _resolveComponent("IntroInterests");
  var _component_NewLogin = _resolveComponent("NewLogin");
  var _component_WalkthroughComponent = _resolveComponent("WalkthroughComponent");
  var _component_TopActionBar = _resolveComponent("TopActionBar");
  var _component_CameraComponent = _resolveComponent("CameraComponent");
  var _component_VideoComponent = _resolveComponent("VideoComponent");
  var _component_ImageUploadComponent = _resolveComponent("ImageUploadComponent");
  var _component_CameraPermissionsNeeded = _resolveComponent("CameraPermissionsNeeded");
  var _component_AssistantTools = _resolveComponent("AssistantTools");
  var _component_DrawingCanvas = _resolveComponent("DrawingCanvas");
  var _component_InstallPWA = _resolveComponent("InstallPWA");
  var _component_BarChart = _resolveComponent("BarChart");
  var _component_MapComponent = _resolveComponent("MapComponent");
  var _component_todoComponent = _resolveComponent("todoComponent");
  var _component_notesComponent = _resolveComponent("notesComponent");
  var _component_CallsComponent = _resolveComponent("CallsComponent");
  var _component_SnackbarComponent = _resolveComponent("SnackbarComponent");
  var _component_MainApplication = _resolveComponent("MainApplication");
  var _component_LoaderComponent = _resolveComponent("LoaderComponent");
  var _component_BottomBar = _resolveComponent("BottomBar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.notsupportedbrowser ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(_toDisplayString(_ctx.browser) + " is currently not supported! Please use ", 1), _hoisted_2, _createTextVNode(" to use this application. ")])) : _createCommentVNode("", true), _ctx.showRedirectPage ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), !_ctx.notsupportedbrowser && _ctx.$store.state.showPurchaseTokens ? (_openBlock(), _createBlock(_component_PurchaseTokens, {
    key: 2
  })) : _createCommentVNode("", true), false && _ctx.$store.state.showMainApplication && !_ctx.$store.state.hideBluetoothController && _ctx.$store.state.userEmail === 'hello@aivitar.com' ? (_openBlock(), _createBlock(_component_BluetoothRingController, {
    key: 3
  })) : _createCommentVNode("", true), !_ctx.notsupportedbrowser && _ctx.$store.state.showWebsite ? (_openBlock(), _createBlock(_component_WebsiteComponent, {
    key: 4,
    style: {
      "overflow-y": "auto"
    }
  })) : _createCommentVNode("", true), !_ctx.notsupportedbrowser && !_ctx.$store.state.showWebsite ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_ctx.$store.state.goDark && _ctx.$store.state.showMainApplication ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": "godark",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateGoDark', false);
    })
  })) : _createCommentVNode("", true), _ctx.$store.state.showLargeImage && _ctx.$store.state.showMainApplication ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    "class": "largeImage__viewer",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      _ctx.$store.commit('updateShowLargeImage', false);
    })
  }, [_createElementVNode("img", {
    src: _ctx.$store.state.largeImageURL,
    "class": "largeImage"
  }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), _ctx.$store.state.showTokensFalling ? (_openBlock(), _createBlock(_component_TokensFalling, {
    key: 2
  })) : _createCommentVNode("", true), _ctx.$store.state.showFloatingImage && _ctx.$store.state.showMainApplication && _ctx.$store.state.textOnlyMode === false ? (_openBlock(), _createBlock(_component_FloatingImage, {
    key: 3
  })) : _createCommentVNode("", true), _ctx.$store.state.showExperienceSelector ? (_openBlock(), _createBlock(_component_ExperienceSelector, {
    key: 4
  })) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication && false ? (_openBlock(), _createBlock(_component_VoiceController, {
    key: 5
  })) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_MainMenu, {
    key: 6
  })) : _createCommentVNode("", true), _ctx.$store.state.leaveReview && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_LeaveReview, {
    key: 7
  })) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication && _ctx.$store.state.showDownvoteComponent ? (_openBlock(), _createBlock(_component_DownvoteComponent, {
    key: 8
  })) : _createCommentVNode("", true), _ctx.$store.state.upgradeVoicesScreen ? (_openBlock(), _createBlock(_component_UpgradeVoices, {
    key: 9
  })) : _createCommentVNode("", true), _ctx.$store.state.showStore && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_ClothingStore, {
    key: 10
  })) : _createCommentVNode("", true), _ctx.$store.state.enableHandleAIResponses && _ctx.$store.state.userUID ? (_openBlock(), _createBlock(_component_HandleAIResponse, {
    key: 11
  })) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_ActivityLogs, {
    key: 12
  })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_ActionBar, null, null, 512), [[_vShow, !_ctx.$store.state.showLimitsReachedPage && _ctx.$store.state.avatarPreloaded && _ctx.$store.state.showMainApplication && !_ctx.$store.state.preventIntroExperience]]), _ctx.$store.state.showLocationPermissionsScreen && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_LocationsPermissionsNeeded, {
    key: 13
  })) : _createCommentVNode("", true), _ctx.$store.state.showAppFeatures && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_AppFeatures, {
    key: 14
  })) : _createCommentVNode("", true), _ctx.$store.state.showPermissionsScreen && _ctx.$store.state.showMainApplications ? (_openBlock(), _createBlock(_component_PermissionsComponent, {
    key: 15
  })) : _createCommentVNode("", true), _ctx.$store.state.showAvatarSelectorIntro || _ctx.$store.state.showMainApplication && _ctx.$store.state.showAvatarSelector ? (_openBlock(), _createBlock(_component_NewAvatarSelector, {
    key: 16
  })) : _createCommentVNode("", true), _ctx.$store.state.showUpgradeMembershipPage === 'true' || _ctx.$store.state.showUpgradeMembershipPage === true ? (_openBlock(), _createBlock(_component_UpgradeMembership, {
    key: 17
  })) : _createCommentVNode("", true), _ctx.$store.state.showFAQ && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_faqComponent, {
    key: 18
  })) : _createCommentVNode("", true), !_ctx.$store.state.showExperienceSelector && _ctx.$store.state.showMainApplication && !_ctx.$store.state.preventIntroExperience ? (_openBlock(), _createBlock(_component_Pageloader, {
    key: 19,
    "class": _normalizeClass({
      'blur-out-intro': _ctx.$store.state.startIntroFade,
      fadeOut: _ctx.$store.state.showMainEntryLoader === false
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _ctx.showLogin && _ctx.$store.state.showLoginPage ? (_openBlock(), _createBlock(_component_UserRegistrationPurple, {
    key: 20
  })) : _createCommentVNode("", true), _ctx.$store.state.showUserLoginBlue ? (_openBlock(), _createBlock(_component_UserLoginBlue, {
    key: 21
  })) : _createCommentVNode("", true), _ctx.$store.state.introAppExpectations ? (_openBlock(), _createBlock(_component_AppExpectations, {
    key: 22
  })) : _createCommentVNode("", true), _ctx.$store.state.introSexualHowTo ? (_openBlock(), _createBlock(_component_IntroSexualHowTo, {
    key: 23
  })) : _createCommentVNode("", true), _ctx.$store.state.introShowXRatedConfirmation ? (_openBlock(), _createBlock(_component_ShowXRatedConfirmation, {
    key: 24
  })) : _createCommentVNode("", true), _ctx.$store.state.introCompanionPreference ? (_openBlock(), _createBlock(_component_CompanionPreference, {
    key: 25
  })) : _createCommentVNode("", true), _ctx.$store.state.introCustomerGender ? (_openBlock(), _createBlock(_component_CustomerGender, {
    key: 26
  })) : _createCommentVNode("", true), _ctx.$store.state.introGallery ? (_openBlock(), _createBlock(_component_IntroGallery, {
    key: 27
  })) : _createCommentVNode("", true), _ctx.$store.state.introQuickMessage ? (_openBlock(), _createBlock(_component_IntroQuickMessage, {
    key: 28
  })) : _createCommentVNode("", true), _ctx.$store.state.introAvatarViewer ? (_openBlock(), _createBlock(_component_IntroAvatarViewer, {
    key: 29
  })) : _createCommentVNode("", true), _ctx.$store.state.introVoice ? (_openBlock(), _createBlock(_component_IntroVoice, {
    key: 30
  })) : _createCommentVNode("", true), _ctx.$store.state.introPersonality ? (_openBlock(), _createBlock(_component_IntroPersonality, {
    key: 31
  })) : _createCommentVNode("", true), _ctx.$store.state.introInterests ? (_openBlock(), _createBlock(_component_IntroInterests, {
    key: 32,
    "class": _normalizeClass({
      'blur-out-intro': _ctx.$store.state.startIntroFade
      // NoIntroPointerEvents: $store.state.noIntroPointerEvents,
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _ctx.showLogin && false ? (_openBlock(), _createBlock(_component_NewLogin, {
    key: 33
  })) : _createCommentVNode("", true), !_ctx.$store.state.showUpgradeMembershipPage && _ctx.$store.state.showWalkThrough && _ctx.$store.state.showMainApplication && _ctx.$store.state.selectedGalleryAvatar && !_ctx.$store.state.preventIntroExperience ? (_openBlock(), _createBlock(_component_WalkthroughComponent, {
    key: 34
  })) : _createCommentVNode("", true), !_ctx.$store.state.showPasswordReset && _ctx.$store.state.showMainApplication && !_ctx.$store.state.showCalls && !_ctx.$store.state.preventIntroExperience ? _withDirectives((_openBlock(), _createBlock(_component_TopActionBar, {
    key: 35,
    "class": "TopActionBar"
  }, null, 512)), [[_vShow, !_ctx.$store.state.showLimitsReachedPage && _ctx.$store.state.avatarPreloaded]]) : _createCommentVNode("", true), _ctx.$store.state.showCamera && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_CameraComponent, {
    key: 36,
    "class": _normalizeClass({
      cameraPhotoTaken: true,
      photo__shrink: _ctx.$store.state.photo && _ctx.$store.state.smallPhoto,
      photo__enlarge: _ctx.$store.state.photo && !_ctx.$store.state.smallPhoto
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _ctx.$store.state.showVideo && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_VideoComponent, {
    key: 37,
    "class": _normalizeClass({
      cameraPhotoTaken: true,
      photo__shrink: _ctx.$store.state.photo && _ctx.$store.state.smallPhoto,
      photo__enlarge: _ctx.$store.state.photo && !_ctx.$store.state.smallPhoto
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _ctx.$store.state.showImageUploader && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_ImageUploadComponent, {
    key: 38,
    "class": _normalizeClass({
      cameraPhotoTaken: true,
      photo__shrink: _ctx.$store.state.photo && _ctx.$store.state.smallPhoto,
      photo__enlarge: _ctx.$store.state.photo && !_ctx.$store.state.smallPhoto
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _ctx.$store.state.showCameraPermissionsScreen === true && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_CameraPermissionsNeeded, {
    key: 39
  })) : _createCommentVNode("", true), _ctx.$store.state.showAssistantTools && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_AssistantTools, {
    key: 40
  })) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_ctx.$store.state.showDrawingPad && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_DrawingCanvas, {
    key: 0,
    "class": "DrawingCanvas"
  })) : _createCommentVNode("", true), _ctx.showInstallPrompt ? (_openBlock(), _createBlock(_component_InstallPWA, {
    key: 1
  })) : _createCommentVNode("", true), !_ctx.$store.state.showChatHistory && _ctx.$store.state.floatingTextAI && _ctx.$store.state.floatingTextAI.length && _ctx.$store.state.floatingTextAI.length > 2 && _ctx.$store.state.showMainApplication ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$store.state.floatingTextAI), 1)) : _createCommentVNode("", true), _ctx.$store.state.floatingText != '' && _ctx.$store.state.showMainApplication ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$store.state.floatingText), 1)) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_BarChart, {
    key: 4,
    "class": "barchartoplevel"
  })) : _createCommentVNode("", true), _ctx.$store.state.hideMapInitial == false ? _withDirectives((_openBlock(), _createBlock(_component_MapComponent, {
    key: 5,
    "class": "map"
  }, null, 512)), [[_vShow, _ctx.$store.state.showMainApplication && _ctx.$store.state.showMap]]) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication && _ctx.$store.state.showToDoList ? (_openBlock(), _createBlock(_component_todoComponent, {
    key: 6,
    "class": "todoComponent"
  })) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication && _ctx.$store.state.showNotes ? (_openBlock(), _createBlock(_component_notesComponent, {
    key: 7,
    "class": "notesComponent"
  })) : _createCommentVNode("", true), _ctx.$store.state.showMainApplication && _ctx.$store.state.showCalls ? (_openBlock(), _createBlock(_component_CallsComponent, {
    key: 8,
    "class": "callsComponent"
  })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.snackbars, function (snackbar, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_SnackbarComponent, {
      key: 0,
      color: snackbar.color,
      text: snackbar.text
    }, null, 8, ["color", "text"])) : _createCommentVNode("", true)]);
  }), 128)), _ctx.$store.state.showMainApplication && !_ctx.$store.state.preventIntroExperience ? (_openBlock(), _createBlock(_component_MainApplication, {
    key: 9,
    "class": "toplevelWebsiteComponent"
  })) : _createCommentVNode("", true), _ctx.$store.state.isThinking && _ctx.$store.state.showMainApplication ? (_openBlock(), _createBlock(_component_LoaderComponent, {
    key: 10,
    largeText: "Thinking",
    smallText: "The a.i is...."
  })) : _createCommentVNode("", true), !_ctx.$store.state.showPasswordReset && _ctx.$store.state.showMainApplication && _ctx.$store.state.showMainApplication && !_ctx.$store.state.preventIntroExperience ? _withDirectives((_openBlock(), _createBlock(_component_BottomBar, {
    key: 11
  }, null, 512)), [[_vShow, !_ctx.$store.state.showLimitsReachedPage && _ctx.$store.state.avatarPreloaded]]) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
}